import {
  Icon,
  IconButton,
  MenuItem,
  styled,
} from '@nextiva/next-ui-components';

export const Item = styled(MenuItem)`
  font-size: 0.9rem;
  & div {
    padding-left: 20px;
  }
`;

export const StyledMenuIconButton = styled(IconButton)`
  margin-right: 81px;
  float: right;
`;

export const StyledMenuIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
`;
